/**
 * Microsoft Clarity - Cart Session Saver
 * Attaches Clarity session data to Shopify cart attributes.
 */
(function() {
  const CLARITY_PROJECT_ID = 'syh3anmipt';

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  function getClarityData() {
    const clck = getCookie('_clck');
    const clsk = getCookie('_clsk');
    if (!clck || !clsk) return null;

    // Decode in case the cookies are URL-encoded
    const decodedClck = decodeURIComponent(clck);
    const decodedClsk = decodeURIComponent(clsk);

    // _clck and _clsk values look like ID|x|y (older) or ID^x^y (newer Clarity versions)
    const userId = decodedClck.split(/[|^]/)[0];
    const sessionId = decodedClsk.split(/[|^]/)[0];

    return {
      userId,
      sessionId,
      recordingUrl: `https://clarity.microsoft.com/player/${CLARITY_PROJECT_ID}/${userId}/${sessionId}`
    };
  }

  const MAX_COOKIE_RETRIES = 5;

  async function updateCartWithClarity(attempt = 0) {
    try {
      const data = getClarityData();
      if (!data) {
        // The Clarity tag loads async, so its cookies may not exist yet on the first pageview
        if (attempt < MAX_COOKIE_RETRIES) setTimeout(() => updateCartWithClarity(attempt + 1), 1000);
        return;
      }

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      // Never write to an empty cart: that would persist a cart for every browse-only visitor
      if (!cart.item_count) return;

      const attributes = cart.attributes || {};
      const updates = {
        _clarity_user_id: data.userId,
        _clarity_session_id: data.sessionId,
        _clarity_recording_url: data.recordingUrl
      };

      if (!attributes._clarity_first_session_url) {
        updates._clarity_first_session_url = data.recordingUrl;
      }

      const changed = Object.keys(updates).some((key) => attributes[key] !== updates[key]);
      if (!changed) return;

      await fetch('/cart/update.js?source=clarity', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: updates })
      });
    } catch (e) {
      // Tracking must never break the storefront
    }
  }

  // Hook into cart updates
  let updateTimeout;
  const debouncedUpdate = () => {
    clearTimeout(updateTimeout);
    updateTimeout = setTimeout(() => updateCartWithClarity(), 1000);
  };

  // Listen for fetch requests to cart APIs
  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const response = await originalFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
    
    if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
      if (!url.includes('source=clarity')) { // prevent infinite loop from our own update
        debouncedUpdate();
      }
    }
    return response;
  };

  // Listen for XHR requests to cart APIs (just in case some older scripts or Shopify components use it)
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, rawUrl) {
    const url = String(rawUrl);
    this.addEventListener('load', function() {
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
        if (!url.includes('source=clarity')) {
          debouncedUpdate();
        }
      }
    });
    originalOpen.apply(this, arguments);
  };

  // Run once on load just to be sure
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateCartWithClarity());
  } else {
    updateCartWithClarity();
  }

})();
